import { Component, OnInit, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { OkrConvergenceService } from "src/app/shared/services/okr-convergence.service";
import { OkrDialogComponent } from "../../okr-dialog/okr-dialog.component";
import { MessageService } from "src/app/shared/services/message.service";
import textConfiguration from "src/assets/static-text-configuration.json";

@Component({
  selector: "app-okr-listing",
  templateUrl: "./okr-listing.component.html",
  styleUrls: ["./okr-listing.component.scss"],
})
export class OkrListingComponent implements OnInit {
  commonText: any = (textConfiguration as any).common;
  @Input() OKRList: any;
  @Input() showOnlyObjectives = false;
  @Input() currentObjective: any = null;
  @Input() showMonths = false;
  tableColumns = [
    "#",
    "MOS",
    "Value",
    "Target Value",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  mosList: any;
  constructor(
    private readonly okrConvergenceService: OkrConvergenceService,
    private readonly dialog: MatDialog,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    if (this.currentObjective) {
      this.getSubscribeOKRData();
    }
  }

  async getSubscribeOKRData() {
    this.messageService.getSubscribeOKRData().subscribe((res: any) => {
      this.OKRList = res;
      this.autoScroll();
    });
  }

  autoScroll() {
    setTimeout(() => {
      const dialogElement: any =
        document.getElementsByClassName("okr-dialog")[0];
      const keplerElement = dialogElement.querySelector(
        `#obj-${this.currentObjective.id}`
      ) as HTMLElement;
      if (keplerElement) {
        keplerElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 1000);
  }

  getMos() {
    this.okrConvergenceService.getMosMaster().subscribe((res: any) => {
      this.mosList = res;
    });
  }
  getMosInfo(item: any) {
    return this.mosList.filter((e: any) => e.id === item)[0];
  }

  showDetailedDialog(objective: any) {
    if (this.showOnlyObjectives) {
      this.dialog.open(OkrDialogComponent, {
        width: "80vw",
        height: "100vh",
        disableClose: true,
        autoFocus: false,
        data: {
          okrData: this.OKRList,
          currentObjective: objective,
        },
      });
    }
  }
}
